$(document).ready(function () {

    var url = window.location.href;

    /* Chrome iOS Bugfix */

    var bg = $('.c-header');
    var $bgheight = $('.c-header').height();
    bg.height($bgheight);
    $(window).resize(function(){
        bg.height($bgheight);
    });



    /* END Chrome iOS Bugfix */

    var els = $('.c-textelement-centered').add('.c-imagebox');

    $.each(els, function () {

        $('.c-textelement-centered__morelink').on('click touchstart', function (e) {
            var id = $(this).attr('href');
            $(id).stop().slideToggle();
            $(this).toggleClass('is-hidden');
            $(this).next('.c-textelement-centered__lesslink').toggleClass('is-hidden');
            e.preventDefault();
        });

        $('.c-textelement-centered__lesslink').on('click touchstart', function (e) {
            var id = $(this).attr('href');
            $(id).stop().slideToggle();
            $(this).toggleClass('is-hidden');
            $(this).prev('.c-textelement-centered__morelink').toggleClass('is-hidden');
            e.preventDefault();
        });

    });

    $('.c-contentslider').slick({
        infinite: true,
        nextArrow: '<button type="button" class="o-sliderarrows o-sliderarrows--next"><svg class="o-icon o-icon__xxlarge"><use xlink:href="'+url+'#slider_right"></use></svg></button>',
        prevArrow: '<button type="button" class="o-sliderarrows o-sliderarrows--prev"><svg class="o-icon o-icon__xxlarge"><use xlink:href="'+url+'#slider_left"></use></svg></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    adaptiveHeight: true,
                    dots: true
                }
            },
        ]
    });

    $('.c-contentslider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        if (!$('body').hasClass('mobile')) {
            $('.c-contentslider__figure')
                .velocity("stop")
                .velocity({opacity: 0}, {duration: 100});
            $('.c-contentslider__title')
                .velocity("stop")
                .velocity({opacity: 0}, {duration: 100});
        }
    });

    $('.c-contentslider').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        if (!$('body').hasClass('mobile')) {
            $('.c-contentslider__figure')
                .velocity('transition.slideDownBigIn', {delay: 1000, duration: 1500});
            $('.c-contentslider__title')
                .velocity({opacity: 1}, {delay: 0, duration: 1500});
        }
    });

    $('.c-imageslider').slick({
        infinite: true,
        nextArrow: '<button type="button" class="o-sliderarrows o-sliderarrows--next"><svg class="o-icon o-icon__xlarge"><use xlink:href="'+url+'#slider_right"></use></svg></button>',
        prevArrow: '<button type="button" class="o-sliderarrows o-sliderarrows--prev"><svg class="o-icon o-icon__xlarge"><use xlink:href="'+url+'#slider_left"></use></svg></button>',
    });

    /*Tipped.create('.c-popover__trigger', {
     skin: 'light',
     size: 'large',
     radius: false,
     position: 'bottom'
     });*/

    function onScrollInit(items, trigger) {
        items.each(function () {
            var osElement = $(this),
                osAnimationClass = osElement.attr('data-ca-animation'),
                osAnimationDelay = osElement.attr('data-ca-animation-delay');

            osElement.css({
                '-webkit-animation-delay': osAnimationDelay,
                '-moz-animation-delay': osAnimationDelay,
                'animation-delay': osAnimationDelay
            });

            var osTrigger = ( trigger ) ? trigger : osElement;

            osTrigger.waypoint(function () {
                osElement.addClass('is-animated').addClass(osAnimationClass);
            }, {
                triggerOnce: true,
                offset: '90%'
            });
        });
    }

    if (!$('body').hasClass('mobile')) {
        onScrollInit($('.ca-animation'));
    }

    if ($('body').hasClass('mobile')) {
        var bigSlideAPI = ($('.c-topnav__link').bigSlide({
            menu: '#c-offpanel',
            side: 'right',
            menuWidth: '80%',
        })).bigSlideAPI;
    } else {
        var bigSlideAPI = ($('.c-topnav__link').bigSlide({
            menu: '#c-offpanel',
            side: 'right',
            menuWidth: '30em',
        })).bigSlideAPI;
    }

    $('.c-topnav__link').on('click touchstart', function (e) {
        $('body').toggleClass('do-not-scroll');
        $('html').toggleClass('do-not-scroll');
        $('.c-navicon').toggleClass('is-clicked');
        e.preventDefault();
    });

    $('.c-offpanel__close').on('click touchstart', function (e) {
        e.preventDefault();
        bigSlideAPI.view.toggleClose();
        //$('.o-icon--burger').fadeToggle('fast');
        //$('.o-icon--close').fadeToggle('fast');
        $('.c-navicon').removeClass('is-clicked');
        $('body').toggleClass('do-not-scroll');
        $('html').toggleClass('do-not-scroll');
        $('.c-offpanel-curtain').toggleClass('is-visible');
    });

    $('.c-offpanel-curtain').on('click touchstart', function (e) {
        e.preventDefault();
        bigSlideAPI.view.toggleClose();
        $('.c-navicon').removeClass('is-clicked');
        $('body').toggleClass('do-not-scroll');
        $('html').toggleClass('do-not-scroll');
        $(this).toggleClass('is-visible');
    });

    $('.o-ghost--vimeo').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,

        fixedContentPos: false
    });

    $('.lightbox').magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        mainClass: 'mfp-img-mobile',
        image: {
            verticalFit: true
        }
    });

    $('.c-topnav__link--menu').on('click touchstart', function () {
        //$('.o-icon--burger').fadeToggle('fast');
        //$('.o-icon--close').fadeToggle('fast');
        $('.c-offpanel-curtain').toggleClass('is-visible');
    });

    $('.c-form--search input').on('focus', function () {
        $(this).closest('.widget-text').addClass('input--animated');
    });

    if ($('.c-searchengine__form input.text').length) {
        if ($('.c-searchengine__form input.text').val().length > 0) {
            $('.c-searchengine__form input.text').closest('.widget-text').addClass('input--animated');
        }
    }

    $('.c-form--search input').on('blur', function () {
        if ($(this).val().length === 0) {
            $(this).closest('.widget-text').removeClass('input--animated');
        }
    });

    /*$(function() {
     var $container = $('.c-header');
     var $b = $('.c-header__inside .mod_boxes4ward');
     var logo = $('.c-logo__svg use');
     $container.waypoint({
     handler: function(d) {
     $b.toggleClass('is-sticky', d === 'down');
     if(logo.attr('xlink:href') === window.location.href + '#crown') {
     logo.attr('xlink:href', window.location.href + '#logo');
     } else {
     logo.attr('xlink:href', window.location.href + '#crown');
     }
     },
     offset: ($b.outerHeight(true) * -1)
     });

     });*/

    //$('.c-header__inside .mod_boxes4ward').addClass('is-sticky');

    //$('.c-header__inside .mod_boxes4ward').unveiledNavigation();

    // hide #back-top first
    $(".scroller").hide();

    var previousScroll = 0,
        navbar = $('.c-header__inside .mod_boxes4ward'),
        logo = $('.c-logo__svg use'),
        navBarOrgOffset = navbar.offset().top + navbar.height();
    headertitle = $('.c-headertitle');
    headertitlearticle = $('#startseite-titel');
    headerheight = $('header').height();
    if (headertitlearticle.length) {
        headertitlearticletop = headertitlearticle.offset().top;
        headertitlearticlewidth = headertitlearticle.width();
    }
    headerbarheight = $('.c-header__inside').height();

    //$('.c-header__inside').height(navbar.height());

    $(window).scroll(function () {

        var currentScroll = $(this).scrollTop();

        if (currentScroll > (headerheight / 2)) {
            if (currentScroll > previousScroll) {

                navbar.stop().fadeOut(function () {
                    logo.attr('xlink:href', window.location.href + '#logo');
                });

                if (headertitlearticle.length) {
                    headertitlearticle.addClass('fixer').css({
                        'top': headertitlearticletop,
                        'width': headertitlearticlewidth,
                        'margin-left' : -(headertitlearticlewidth/2)
                    });
                }
            } else {
                logo.attr('xlink:href', window.location.href + '#crown');
                navbar.stop().fadeIn();
                navbar.addClass('is-sticky');

            }
        } else {
            if (navbar.hasClass('is-sticky')) {
                navbar.stop().fadeOut(function () {

                    navbar.removeClass('is-sticky');
                    logo.attr('xlink:href', window.location.href + '#logo');
                    if (headertitlearticle.length) {
                        headertitlearticle.removeClass('fixer').css({'top': 'auto', 'width': 'auto', 'margin-left': '0'});
                    }
                    navbar.stop().fadeIn();
                });
            }
        }
        previousScroll = currentScroll;

        if ($(this).scrollTop() > 100) {
            $('.scroller').fadeIn();
        } else {
            $('.scroller').fadeOut();
        }
    });


    // scroll body to 0px on click
    $('.scroller').click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 800);
        return false;
    });

    $(function () {
        $('.to-contactform').click(function () {
            $('body,html').animate({
                scrollTop: $('#f1').offset().top
            }, 800);
            return false;
        });
    });

    // --------------------------------------------------------------
    // Animations

    // Trains
    function animateTrains() {
        var railsY = 0;
        $('.rails').each(function () {
            $(this)
                .velocity(
                    {
                        fill: '#9c9c9c',
                        translateY: railsY,
                    }
                )
                .velocity(
                    "fadeIn", {
                        duration: 500,
                        delay: 0,
                    }
                );
            railsY += 60;
        });

        var tX = 0;
        var delay = 1250;

        $('.train').each(function () {
            $(this)
                .velocity(
                    {
                        translateX: 600,
                        translateY: tX,
                        fill: '#9c9c9c',
                    }, {
                        duration: 0,
                        delay: 0,
                    }
                )
                .velocity(
                    {
                        translateX: 0,
                    }, {
                        duration: 1500,
                        delay: delay,
                        easing: 'easeOut',
                        display: 'block',
                    }
                );
            delay -= 250;
            tX += 60;
        });
    };

    $('#trains').waypoint(function (direction) {
        animateTrains();
        this.destroy();
    }, {
        offset: 'bottom-in-view',
    });

    // Haushalte

    function animateHouses() {
        var iDelay = 500;
        $('.house')
                .velocity({fill: '#ffffff'}, {})
                .velocity("transition.expandIn", {delay: iDelay});
    };

    $('#houses').waypoint(function (direction) {
        animateHouses();
        this.destroy();
    }, {
        offset: 'bottom-in-view',
    });

    // Mountain

    function animateMountain() {
        var iDelay = 500;
        $('#mountain')
        //.velocity({ opacity: 0 })
            .velocity({fill: '#fff'}, {})
            //.velocity({ opacity: 1 }, {duration: 250, delay: iDelay})
            .velocity("transition.expandIn", {delay: iDelay});
        //.velocity("reverse", { delay: 250 });
        $('#mountain_stroke')
            .velocity({stroke: '#fff'}, {})
            .velocity("transition.expandIn", {delay: 1500 + iDelay});
    };

    $('#mountain').waypoint(function (direction) {
        animateMountain();
        this.destroy();
    }, {
        offset: 'bottom-in-view',
    });

    //Soccer

    function animateSoccer() {
        var iDelay = 500;
        $('.item')
            //.velocity({ opacity: 0 })
                .velocity({fill: '#9c9c9c'}, {})
                //.velocity({ opacity: 1 }, {duration: 250, delay: iDelay})
                .velocity("transition.expandIn", {delay: iDelay});
            //.velocity("reverse", { delay: 250 });
    };

    $('#soccerfield').waypoint(function () {
        animateSoccer();
        this.destroy();
    }, {
        offset: 'bottom-in-view'
    });

    // Tower

    function animateTower() {
        var iDelay = 500;
        $('#tower')
            //.velocity({ opacity: 0 })
                .velocity({fill: '#9c9c9c'}, {})
                //.velocity({ opacity: 1 }, {duration: 250, delay: iDelay})
                .velocity("transition.expandIn", {delay: iDelay});
            //.velocity("reverse", { delay: 250 });
            iDelay += 150;
        $('#tower_stroke')
            .velocity("transition.expandIn", {delay: 1500 + iDelay});
    }

    $('#tower').waypoint(function () {
        animateTower();
        this.destroy();
    }, {
        offset: 'bottom-in-view'
    });

    // Elephant

    function animateElephant() {
        var iDelay = 500;
        $('#elephant')
            //.velocity({ opacity: 0 })
                .velocity({fill: '#fff'}, {})
                //.velocity({ opacity: 1 }, {duration: 250, delay: iDelay})
                .velocity("transition.expandIn", {delay: iDelay});
            //.velocity("reverse", { delay: 250 });
            iDelay += 150;
    }

    $('#elephant').waypoint(function () {
        animateElephant();
        this.destroy();
    }, {
        offset: 'bottom-in-view'
    });

    $(document).on('click', '.c-ajax__confirm', function () {
        $('.c-ajax__confirm').fadeOut();
    });

    $('.c-offpanel__closebutton').hover(function () {
        $('#right_top').stop().velocity({
            translateX: '10px',
            translateY: '-10px'
        }, {})
        $('#right_bottom').stop().velocity({
            translateX: '10px',
            translateY: '10px'
        }, {})
        $('#left_top').stop().velocity({
            translateX: '-10px',
            translateY: '-10px'
        }, {})
        $('#left_bottom').stop().velocity({
            translateX: '-10px',
            translateY: '10px'
        }, {})
    }, function () {
        $('#right_top').stop().velocity({
            translateX: '0',
            translateY: '0'
        }, {})
        $('#right_bottom').stop().velocity({
            translateX: '0',
            translateY: '0'
        }, {})
        $('#left_top').stop().velocity({
            translateX: '0',
            translateY: '0'
        }, {})
        $('#left_bottom').stop().velocity({
            translateX: '0',
            translateY: '0'
        }, {})
    });

    /**
     *
     * Daten & Fakten Animation
     *
     */

    $('.c-factline').velocity({opacity: 0}, {duration: 0});
    $('.c-factline__itemscontainer').velocity({opacity: 0}, {duration: 0});

    /*$('.c-factline').waypoint(function () {
     $(this).velocity({opacity: 1}, { duration: 1500 });
     //.velocity('transition.slideDownBigIn', { delay: 1000, duration: 1500 });
     //$(this).destroy();
     }, {
     offset: 'bottom-in-view'
     });*/

    var factlines = $('.c-factline').each(function () {
        $(this).waypoint(function (direction) {
            var el = $(this.element);
            el.velocity({opacity: 1}, {duration: 500});
            el.find('img').velocity({opacity: .2}, {duration: 500, delay: 1500});
            //$.Velocity.hook(el.find('.c-factline__itemscontainer'), 'translateX', '-50%');
            $.Velocity.hook(el.find('.c-factline__itemscontainer'), 'translateY', '-50%');
            el.find('.c-factline__itemscontainer')
                .velocity({
                    opacity: 1
                }, {
                    delay: 2000, duration: 1000,
                });
            this.destroy();
        }, {
            offset: 'bottom-in-view'
        });
    });

    /*
     Move first fact-line over the line
     */

    //var factImage = $('.c-factline').first().outerHeight(true);

    //$('.c-factline').first().css('margin-top', (-1 * factImage));

});
